<div [formGroup]="detailsPageForm" dashboardConnectForm [connectForm]="selectedSubsection?.detail">
  <div class="dashboard-details-page">
    <div class="dashboard-details-page__form" fxLayout="column" fxLayoutAlign="center">
      <div *ngIf="selectedSection?.type !== SectionType.DIMENSION">
        <mat-tab-group
          mat-align-tabs="end"
          (selectedTabChange)="selectTemplateLanguage($event)"
          #languageTabs
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language?.name">
            <ng-container *ngTemplateOutlet="tabContent"></ng-container>
          </mat-tab>
        </mat-tab-group>
        <ng-template #tabContent>
          <div formArrayName="detailTranslations" *ngFor="let item of detailTranslations.controls; let i = index">
            <mat-form-field
              [formGroupName]="i"
              *ngIf="
                item.get('language').value === selectedLanguage?.code && item.get('identifier').value === DETAIL_TITLE
              "
              fxFlex="100"
            >
              <input matInput formControlName="translation" [placeholder]="'Detail Title'" />
              <mat-error
                *ngIf="item.get('identifier').value === DETAIL_TITLE && item.get('translation').hasError('maxlength')"
              >
                Detail Title should have
                <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong> characters
              </mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
      <dashboard-image-upload
        *ngIf="selectedSection?.type !== SectionType.DIMENSION"
        formControlName="mediaUrl"
        [label]="'Upload image'"
        [isEdit]="isEditingItem"
        [isImageToEdit]="isImageToEdit"
        [imgPath]="imgPath"
        [keyForUpload]="keyForUpload"
        [idsForUpload]="idsForUpload"
        [size]="IMAGE_SIZES.MEDIUM"
      >
      </dashboard-image-upload>
      <div *ngIf="isEditorInitialized">
        <mat-tab-group
          mat-align-tabs="end"
          animationDuration="0ms"
          #languageTabsEditor
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-template matTabContent>
              <div formArrayName="detailTranslations" *ngFor="let item of detailTranslations?.controls; let i = index">
                <div
                  class="dashboard-details-page__form-text-editor"
                  [formGroupName]="i"
                  *ngIf="
                    item.get('language').value === selectedLanguage?.code &&
                    item.get('identifier').value === DETAIL_TEXT
                  "
                  fxFill
                >
                  <label class="dashboard-details-page__form-text-editor-label">Detail Text</label>
                  <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
